<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submitForm" px-12)
        v-layout(raw wrap)
            v-flex(xs12)

                // String field
                v-text-field(
                    v-if="setting.type === 'string'"
                    name="stringField"
                    :label="$t(`settings.descriptions.${setting.name}`)"
                    ref="stringFieldRef"
                    :value="setting.value"
                    v-on:change="handleValueChange"
                    :loading="isLoading"
                )

                // Boolean field
                v-switch(
                    v-if="setting.type === 'boolean'"
                    name="booleanField"
                    :label="$t(`settings.descriptions.${setting.name}`)"
                    ref="booleanFieldRef"
                    :true-value="true"
                    :false-value="false"
                    :value="setting.value"
                    :input-value="setting.value"
                    v-on:change="handleValueChange"
                    :loading="isLoading"
                )

</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        props: {
            setting: {
                required: true
            }
        },
        data() {
            return {
                model: {
                    stringField: null,
                    password: null,
                    confirmPassword: null
                },
                visibilityPassword: false
            };
        },
        computed: {
            ...mapGetters('settings', ['isLoading'])
        },
        mounted() {},
        methods: {
            ...mapActions('settings', ['update', 'list']),

            /**
             * Update password on submit
             * @returns {Promise<void>}
             */
            async handleValueChange(value) {
                let parsedValue;
                switch (this.setting.type) {
                    case 'string': {
                        parsedValue = value;
                        break;
                    }
                    case 'boolean': {
                        parsedValue = Boolean(value);
                        break;
                    }
                    case 'number': {
                        parsedValue = Number(value);
                        break;
                    }
                }
                await this.update({
                    name: this.setting.name,
                    value: parsedValue
                });
                await this.list();
            }
        }
    };
</script>
